module.exports = __webpack_public_path__ + "static/joshua-waitzkin-741683cc06ef1ca94e1308486b74c7c3.jpg";